export enum TranslationNamespace {
	Common = 'common',
	Chat = 'chat',
	Header = 'header',
	UserSuggest = 'user-suggest',
	Navigation = 'navigation',
	FishCardModal = 'fish-card-modal',
	DigitalOffice = 'digital-office',
	LoginRegistration = 'login-registration',
	ApplicationViewStatus = 'application-view-status',
	InviteDemoModal = 'invite-demo-modal',
	FishProduct = 'fish-product',
	PersonalAccount = 'personal-account',
	Units = 'units',
	CookiesAcceptedPopup = 'cookies-accepted-popup',
	Validation = 'validation',
	PressRelease = 'press-release',
	Applications = 'applications',
	Calculator = 'calculator',
	Exchange = 'exchange',
	FishSearch = 'fish-search',
	Marketing = 'marketing',
	Shared = 'shared',
	StorageAccount = 'storage-account',
	WarehouseSearch = 'warehouse-search',
}
